// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__29K9p","errors":"Errors_errors__zOg99"};